import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Estoque from './pages/Estoque';
import Clientes from './pages/Clientes';
import Financeiro from './pages/Financeiro';
import Admin from './pages/Admin';
import { LayoutDashboard, Bike, Users, Wallet, Menu, X, Bell, LogOut, Shield } from 'lucide-react';

const NAV = [
  { id: 'dashboard',  label: 'Dashboard',   Icon: LayoutDashboard },
  { id: 'estoque',    label: 'Estoque',      Icon: Bike },
  { id: 'clientes',   label: 'Clientes',     Icon: Users },
  { id: 'financeiro', label: 'Financeiro',   Icon: Wallet },
];

const PAGINAS = { dashboard: Dashboard, estoque: Estoque, clientes: Clientes, financeiro: Financeiro, admin: Admin };

export default function App() {
  const [usuario,      setUsuario]      = useState(null);
  const [paginaAtual,  setPaginaAtual]  = useState('dashboard');
  const [sidebarAberta,setSidebarAberta]= useState(false);

  // Persistir sessão no sessionStorage
  useEffect(() => {
    const salvo = sessionStorage.getItem('p67_usuario');
    if (salvo) try { setUsuario(JSON.parse(salvo)); } catch {}
  }, []);

  const handleLogin = (user) => {
    setUsuario(user);
    sessionStorage.setItem('p67_usuario', JSON.stringify(user));
  };

  const handleLogout = () => {
    setUsuario(null);
    sessionStorage.removeItem('p67_usuario');
    setPaginaAtual('dashboard');
  };

  if (!usuario) return <Login onLogin={handleLogin} />;

  const Pagina = PAGINAS[paginaAtual] || Dashboard;
  const isAdmin = usuario.perfil === 'admin';

  return (
    <div className="app-shell">
      {sidebarAberta && <div className="sidebar-overlay" onClick={() => setSidebarAberta(false)} />}

      <aside className={`sidebar ${sidebarAberta ? 'sidebar--open' : ''}`}>
        <div className="sidebar-logo">
          <img src="/logo.jpg" alt="Padrão 67" className="sidebar-logo-img" />
        </div>

        <nav className="sidebar-nav">
          {NAV.map(({ id, label, Icon }) => (
            <button key={id} className={`nav-item ${paginaAtual === id ? 'nav-item--active' : ''}`}
              onClick={() => { setPaginaAtual(id); setSidebarAberta(false); }}>
              <Icon size={20} /><span>{label}</span>
            </button>
          ))}
          {isAdmin && (
            <button className={`nav-item ${paginaAtual === 'admin' ? 'nav-item--active' : ''}`}
              onClick={() => { setPaginaAtual('admin'); setSidebarAberta(false); }}>
              <Shield size={20} /><span>Admin</span>
            </button>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-usuario">
            <div className="usuario-avatar">{usuario.nome?.charAt(0) || usuario.usuario?.charAt(0)}</div>
            <div className="usuario-info">
              <span className="usuario-nome">{usuario.nome || usuario.usuario}</span>
              <span className="usuario-perfil">{usuario.perfil}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout} title="Sair"><LogOut size={16} /></button>
          </div>
        </div>
      </aside>

      <div className="main-wrapper">
        <header className="topbar">
          <button className="topbar-menu-btn" onClick={() => setSidebarAberta(v => !v)}>
            {sidebarAberta ? <X size={22} /> : <Menu size={22} />}
          </button>
          <h1 className="topbar-title">
            {[...NAV, { id:'admin', label:'Administração' }].find(n => n.id === paginaAtual)?.label}
          </h1>
          <button className="topbar-notif"><Bell size={20} /></button>
        </header>

        <main className="main-content">
          <Pagina onNavegar={(id) => { setPaginaAtual(id); setSidebarAberta(false); }} />
        </main>
      </div>

      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --azul: #0B2341; --azul-m: #0F2E58; --amarelo: #F5C400;
          --bg: #F4F6FA; --branco: #FFFFFF; --cinza-l: #F0F2F6;
          --cinza-m: #DDE2EC; --cinza-t: #8A93A2; --texto: #1A2332;
          --verde: #22C55E; --vermelho: #EF4444; --laranja: #F97316;
          --sidebar-w: 240px; --topbar-h: 60px;
        }
        body { font-family: 'Inter', 'Segoe UI', sans-serif; background: var(--bg); color: var(--texto); }
        .app-shell { display: flex; min-height: 100vh; }
        .sidebar { width:var(--sidebar-w); background:var(--azul); display:flex; flex-direction:column; position:fixed; top:0; left:0; height:100vh; z-index:200; transition:transform .25s ease; }
        .sidebar-logo { padding:16px 14px; border-bottom:1px solid rgba(255,255,255,.08); }
        .sidebar-logo-img { width:100%; height:auto; border-radius:8px; display:block; }
        .sidebar-nav { flex:1; padding:16px 12px; display:flex; flex-direction:column; gap:4px; overflow-y:auto; }
        .nav-item { display:flex; align-items:center; gap:12px; padding:11px 14px; border-radius:10px; background:transparent; border:none; cursor:pointer; color:rgba(255,255,255,.65); font-size:14px; font-weight:500; text-align:left; transition:all .18s; width:100%; }
        .nav-item:hover { background:rgba(255,255,255,.07); color:#fff; }
        .nav-item--active { background:rgba(245,196,0,.12); color:var(--amarelo); }
        .sidebar-footer { padding:12px; border-top:1px solid rgba(255,255,255,.08); }
        .sidebar-usuario { display:flex; align-items:center; gap:10px; padding:8px; border-radius:10px; }
        .usuario-avatar { width:34px; height:34px; border-radius:50%; background:var(--amarelo); color:var(--azul); display:flex; align-items:center; justify-content:center; font-weight:800; font-size:.95rem; flex-shrink:0; }
        .usuario-info { flex:1; min-width:0; }
        .usuario-nome { display:block; color:#fff; font-size:.8rem; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
        .usuario-perfil { display:block; color:rgba(255,255,255,.4); font-size:.7rem; text-transform:capitalize; }
        .logout-btn { background:transparent; border:none; color:rgba(255,255,255,.4); cursor:pointer; padding:4px; border-radius:6px; flex-shrink:0; }
        .logout-btn:hover { color:#fff; background:rgba(255,255,255,.1); }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:190; }
        .main-wrapper { flex:1; margin-left:var(--sidebar-w); display:flex; flex-direction:column; min-width:0; }
        .topbar { height:var(--topbar-h); background:var(--azul); display:flex; align-items:center; gap:12px; padding:0 20px; position:sticky; top:0; z-index:100; }
        .topbar-menu-btn { display:none; background:transparent; border:none; color:#fff; cursor:pointer; padding:4px; border-radius:6px; }
        .topbar-title { color:#fff; font-size:17px; font-weight:700; flex:1; }
        .topbar-notif { background:transparent; border:none; color:rgba(255,255,255,.7); cursor:pointer; padding:6px; border-radius:8px; }
        .main-content { flex:1; overflow-y:auto; }
        @media (max-width: 768px) {
          .sidebar { transform: translateX(-100%); }
          .sidebar--open { transform: translateX(0); }
          .sidebar-overlay { display: block; }
          .main-wrapper { margin-left: 0; }
          .topbar-menu-btn { display: flex; }
        }
        .card { background:var(--branco); border-radius:14px; box-shadow:0 1px 3px rgba(0,0,0,.08); padding:20px; }
        .btn { display:inline-flex; align-items:center; gap:8px; padding:10px 18px; border-radius:10px; font-size:14px; font-weight:600; cursor:pointer; border:none; transition:all .18s; }
        .btn-primary { background:var(--azul); color:#fff; }
        .btn-primary:hover { background:var(--azul-m); }
        .btn-secondary { background:var(--cinza-l); color:var(--texto); border:1.5px solid var(--cinza-m); }
        .btn-secondary:hover { background:var(--cinza-m); }
        .btn-ghost { background:transparent; border:1.5px solid var(--cinza-m); color:#6B7280; }
        .btn-ghost:hover { background:#F9FAFB; }
        .btn-sm { padding:6px 12px; font-size:12px; }
        .btn:disabled { opacity:.5; cursor:not-allowed; }
        .badge { display:inline-flex; align-items:center; padding:3px 10px; border-radius:20px; font-size:12px; font-weight:600; }
        .badge-verde { background:#dcfce7; color:#16a34a; }
        .badge-vermelho { background:#fee2e2; color:#dc2626; }
        .badge-laranja { background:#fed7aa; color:#ea580c; }
        .badge-azul { background:#dbeafe; color:#1d4ed8; }
        .badge-cinza { background:var(--cinza-l); color:var(--cinza-t); }
        .input-field { width:100%; padding:10px 14px; border:1.5px solid var(--cinza-m); border-radius:10px; font-size:14px; background:var(--branco); outline:none; transition:border-color .15s; color:var(--texto); }
        .input-field:focus { border-color:var(--azul); }
        .input-field::placeholder { color:var(--cinza-t); }
        .label { font-size:12px; font-weight:600; color:var(--cinza-t); margin-bottom:5px; display:block; text-transform:uppercase; letter-spacing:.4px; }
        .modal-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.55); display:flex; align-items:center; justify-content:center; z-index:1000; padding:16px; }
        .modal { background:var(--branco); border-radius:16px; width:100%; max-width:560px; max-height:90vh; overflow-y:auto; }
        .empty-state { text-align:center; padding:48px 20px; color:var(--cinza-t); }
        .empty-state p { font-size:14px; margin:12px 0; }
        .loading { display:flex; align-items:center; justify-content:center; padding:48px; color:var(--cinza-t); gap:10px; }
        .spinner { width:24px; height:24px; border:3px solid var(--cinza-m); border-top-color:var(--azul); border-radius:50%; animation:spin .7s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
